import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/*Utilities */
class Utilities {
    isNumberArray(arr) {
        return (arr && arr.length && arr.filter((value) => !isNaN(value)).length === arr.length) ? true : false;
    }
    isNullOrEmpty(obj) {
        return obj === undefined || obj === null || obj === '';
    }
    toBoolean(obj, ...allowedValues) {
        return (obj === '' || obj === 'true' || allowedValues.indexOf(obj) !== -1) ? true : false;
    }
    findNextValidStepValue(n, step) {
        const divisorsSet1 = [];
        const divisorsSet2 = [];
        const sqrtNum = Math.sqrt(n);
        let newStep = -1;
        for (let i = 0; i < sqrtNum; i++) {
            if (n % i === 0) {
                if ((n / i) === i) {
                    divisorsSet1.push(i);
                }
                else {
                    divisorsSet1.push(i);
                    divisorsSet2.push(n / i);
                }
            }
        }
        // Picking newStep by checking large set of divisors first
        for (let i = 0; i < divisorsSet2.length; i++) {
            if (step > divisorsSet2[i]) {
                newStep = divisorsSet2[i];
                break;
            }
        }
        if (newStep === -1) { // checking set of small divisors if newStep didn't find out till.
            for (let i = divisorsSet1.length - 1; i >= 0; i--) {
                if (step > divisorsSet1[i]) {
                    newStep = divisorsSet1[i];
                    break;
                }
            }
        }
        return (newStep === -1) ? 1 : newStep;
    }
}

/* Slider Handler Index */
var SliderHandlerEnum;
(function (SliderHandlerEnum) {
    SliderHandlerEnum[SliderHandlerEnum["left"] = 0] = "left";
    SliderHandlerEnum[SliderHandlerEnum["right"] = 1] = "right";
})(SliderHandlerEnum || (SliderHandlerEnum = {}));

class NpnSliderComponent extends Utilities {
    constructor(el) {
        super();
        this.el = el;
        this.sliderModel = [0, 0, 0];
        this.step = 1;
        this.sliderWidth = 0;
        this.totalDiff = 0;
        this.startClientX = 0;
        this.startPleft = 0;
        this.startPRight = 0;
        this.minValue = 0;
        this.maxValue = 0;
        this.minSelected = 0;
        this.maxSelected = 0;
        this.sliderInitiated = false;
        this.initValues = [];
        this.currentValues = [0, 0];
        this.handlerX = [0, 0];
        this.isHandlerActive = false;
        this.isTouchEventStart = false;
        this.isMouseEventStart = false;
        this.currentHandlerIndex = 0;
        this.stepIndicatorPositions = [];
        this.isDisabled = false;
        this.hideTooltip = false;
        this.hideValues = false;
        this.handlerIndex = SliderHandlerEnum;
        this.showStepIndicator = false;
        this.multiRange = true;
        this.onChange = new EventEmitter();
    }
    set setMinValues(value) {
        if (!isNaN(value)) {
            this.minValue = Number(value);
        }
    }
    set setMaxValues(value) {
        if (!isNaN(value)) {
            this.maxValue = Number(value);
        }
    }
    set setMinSelectedValues(value) {
        if (!isNaN(value) && this.minSelected !== Number(value)) {
            this.minSelected = Number(value);
        }
    }
    set setMaxSelectedValues(value) {
        if (!isNaN(value) && this.maxSelected !== Number(value)) {
            this.maxSelected = Number(value);
        }
    }
    set stepValue(value) {
        if (!isNaN(value)) {
            this.step = Number(value);
        }
    }
    set setHideTooltip(value) {
        this.hideTooltip = this.toBoolean(value);
    }
    set setHideValues(value) {
        this.hideValues = this.toBoolean(value);
    }
    set setDisabled(value) {
        this.isDisabled = this.toBoolean(value, 'disabled');
    }
    ngOnInit() {
        this.initializeSlider();
    }
    ngOnChanges(changes) {
        if (this.sliderInitiated) {
            if (!this.isNullOrEmpty(changes['setMinSelectedValues'])
                && changes['setMinSelectedValues'].previousValue === changes['setMinSelectedValues'].currentValue) {
                return;
            }
            if (!this.isNullOrEmpty(changes['setMaxSelectedValues'])
                && changes['setMaxSelectedValues'].previousValue === changes['setMaxSelectedValues'].currentValue) {
                return;
            }
            this.resetModel();
        }
    }
    /*Method to initailize entire Slider*/
    initializeSlider() {
        try {
            // Taking width of slider bar element.
            this.sliderWidth = this.el.nativeElement.children[0].children[0].offsetWidth;
            this.resetModel();
            this.sliderInitiated = true;
        }
        catch (e) {
            console.error(e);
        }
    }
    /*Method to initialize variables and model values */
    resetModel() {
        this.validateSliderValues();
        // Setting the model values
        this.sliderModel = [
            this.currentValues[0] - this.initValues[0],
            this.currentValues[1] - this.currentValues[0],
            this.initValues[1] - this.currentValues[1]
        ];
        this.totalDiff = this.sliderModel.reduce((prevValue, curValue) => prevValue + curValue, 0);
        // Validation for slider step
        if (this.totalDiff % this.step !== 0) {
            const newStep = this.findNextValidStepValue(this.totalDiff, this.step);
            console.warn('Invalid step value "' + this.step + '" : and took "' + newStep + '" as default step');
            this.step = newStep;
        }
        this.initializeStepIndicator();
        this.setHandlerPosition();
    }
    /*Method to do validation of init and seleted range values*/
    validateSliderValues() {
        if (this.isNullOrEmpty(this.minValue) || this.isNullOrEmpty(this.maxValue)) {
            this.updateInitValues([0, 0]);
            this.updateCurrentValue([0, 0], true);
        }
        else if (this.minValue > this.maxValue) {
            this.updateInitValues([0, 0]);
            this.updateCurrentValue([0, 0], true);
        }
        else {
            this.initValues = [this.minValue, this.maxValue];
            /*
            * Validation for Selected range values
            */
            if (this.isNullOrEmpty(this.minSelected) || this.minSelected < this.minValue || this.minSelected > this.maxValue) {
                this.minSelected = this.minValue;
            }
            if (this.isNullOrEmpty(this.maxSelected) || this.maxSelected < this.minValue || this.maxSelected > this.maxValue) {
                this.maxSelected = this.maxValue;
            }
            if (this.minSelected > this.maxSelected) {
                this.minSelected = this.minValue;
                this.maxSelected = this.maxValue;
            }
            this.updateCurrentValue([this.minSelected, this.maxSelected], true);
        }
    }
    /*Method to add step inidicator to slider */
    initializeStepIndicator() {
        if (this.showStepIndicator) {
            this.stepIndicatorPositions.length = 0;
            const numOfStepIndicators = this.totalDiff / this.step;
            if (this.sliderWidth / numOfStepIndicators >= 10) {
                const increment = this.sliderWidth / numOfStepIndicators;
                let leftPosition = increment;
                while (this.stepIndicatorPositions.length < numOfStepIndicators - 1) {
                    this.stepIndicatorPositions.push(+leftPosition.toFixed(2));
                    leftPosition += increment;
                }
            }
            else {
                console.warn(`As 'step' value is too small compared to min & max value difference and slider width,
          Step Indicator can't be displayed!. Provide slight large value for 'step'`);
            }
        }
        else {
            this.stepIndicatorPositions.length = 0;
        }
    }
    /*Method to set current selected values */
    updateCurrentValue(arrayValue, privateChange = false) {
        this.minSelected = this.currentValues[0] = arrayValue[0];
        this.maxSelected = this.currentValues[1] = arrayValue[1];
        if (!privateChange) {
            this.onChange.emit((this.multiRange) ? this.currentValues : [this.currentValues[0]]);
        }
    }
    /*Method to set current selected values */
    updateInitValues(arrayValue) {
        this.minValue = this.initValues[0] = arrayValue[0];
        this.maxValue = this.initValues[1] = arrayValue[1];
    }
    /*Method to set handler position */
    setHandlerPosition() {
        let runningTotal = 0;
        // Updating selected values : current values
        this.updateCurrentValue([
            this.initValues[0] + this.sliderModel[0],
            this.initValues[1] - this.sliderModel[2]
        ]);
        /*Setting handler position */
        for (let i = 0, len = this.sliderModel.length - 1; i < len; i++) {
            runningTotal += this.sliderModel[i];
            this.handlerX[i] = (runningTotal / this.totalDiff) * 100;
        }
    }
    /*Method to set model array values - will try to refine the values using step */
    setModelValue(index, value) {
        if (this.step > 1) {
            value = Math.round(value / this.step) * this.step;
        }
        this.sliderModel[index] = value;
    }
    /*Method to disable handler movement*/
    /*Execute on events:
    * on-mouseup
    * on-panend
    */
    setHandlerActiveOff() {
        this.isMouseEventStart = false;
        this.isTouchEventStart = false;
        this.isHandlerActive = false;
    }
    /*Method to detect start draging handler*/
    /*Execute on events:
    * on-mousedown
    * on-panstart
    */
    setHandlerActive(event, handlerIndex) {
        event.preventDefault();
        if (!this.isDisabled) {
            if (!this.isNullOrEmpty(event.clientX)) {
                this.startClientX = event.clientX;
                this.isMouseEventStart = true;
                this.isTouchEventStart = false;
            }
            else if (!this.isNullOrEmpty(event.deltaX)) {
                this.startClientX = event.deltaX;
                this.isTouchEventStart = true;
                this.isMouseEventStart = false;
            }
            if (this.isMouseEventStart || this.isTouchEventStart) {
                this.currentHandlerIndex = handlerIndex;
                this.startPleft = this.sliderModel[handlerIndex];
                this.startPRight = this.sliderModel[handlerIndex + 1];
                this.isHandlerActive = true;
            }
        }
    }
    /*Method to calculate silder handler movement */
    /*Execute on events:
    * on-mousemove
    * on-panmove
    */
    handlerSliding(event) {
        if ((this.isMouseEventStart && event.clientX) || (this.isTouchEventStart && event.deltaX)) {
            const movedX = Math.round(((event.clientX || event.deltaX) - this.startClientX) / this.sliderWidth * this.totalDiff);
            const nextPLeft = this.startPleft + movedX;
            const nextPRight = this.startPRight - movedX;
            if (nextPLeft >= 0 && nextPRight >= 0) {
                this.setModelValue(this.currentHandlerIndex, nextPLeft);
                this.setModelValue(this.currentHandlerIndex + 1, nextPRight);
                this.setHandlerPosition();
            }
        }
    }
}
NpnSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
NpnSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: NpnSliderComponent, selector: "npn-slider", inputs: { setMinValues: ["min", "setMinValues"], setMaxValues: ["max", "setMaxValues"], setMinSelectedValues: ["minSelected", "setMinSelectedValues"], setMaxSelectedValues: ["maxSelected", "setMaxSelectedValues"], stepValue: ["step", "stepValue"], showStepIndicator: "showStepIndicator", multiRange: "multiRange", setHideTooltip: ["hide-tooltip", "setHideTooltip"], setHideValues: ["hide-values", "setHideValues"], setDisabled: ["disabled", "setDisabled"] }, outputs: { onChange: "onChange" }, host: { listeners: { "document:mouseup": "setHandlerActiveOff()", "document:panend": "setHandlerActiveOff()" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<!--npn-slider template-->\n<div class=\"slider\" [class.disabled]=\"isDisabled\">\n  <div class=\"bar\" (mousemove)=\"handlerSliding($event)\" (panmove)=\"handlerSliding($event)\">\n    <span class=\"left-handle\" [ngClass]=\"{'active': isHandlerActive && currentHandlerIndex === handlerIndex.left,\n                      'last-active': currentHandlerIndex === handlerIndex.left\n                    }\"\n      [style.left.%]=\"handlerX[handlerIndex.left]\" (mousedown)=\"setHandlerActive($event, handlerIndex.left)\" (panstart)=\"setHandlerActive($event, handlerIndex.left)\">\n      <span *ngIf=\"!hideTooltip\" class=\"handle-tooltip\">{{currentValues[handlerIndex.left]}}</span>\n    </span>\n    <div class=\"filler\">\n      <div class=\"step-indicators\">\n        <span *ngFor=\"let stepPos of stepIndicatorPositions\" [style.left.px]=\"stepPos\"></span>\n      </div>\n      <span *ngIf=\"multiRange\" [style.left.%]=\"handlerX[0]\" [style.width.%]=\"handlerX[handlerIndex.right] - handlerX[handlerIndex.left]\"></span>\n      <span *ngIf=\"!multiRange\" [style.left.%]=\"0\" [style.width.%]=\"handlerX[0]\"></span>\n    </div>\n    <span *ngIf=\"multiRange\" class=\"right-handle\" [ngClass]=\"{'active': isHandlerActive && currentHandlerIndex === handlerIndex.right,\n                      'last-active': currentHandlerIndex === handlerIndex.right\n                    }\"\n      [style.left.%]=\"handlerX[handlerIndex.right]\" (mousedown)=\"setHandlerActive($event, handlerIndex.right)\"\n      (panstart)=\"setHandlerActive($event, handlerIndex.right)\">\n      <span *ngIf=\"!hideTooltip\" class=\"handle-tooltip\">{{currentValues[handlerIndex.right]}}</span>\n    </span>\n  </div>\n  <div class=\"values\" *ngIf=\"!hideValues\">\n    <span>{{initValues[handlerIndex.left]}}</span>\n    <span>{{initValues[handlerIndex.right]}}</span>\n  </div>\n</div>\n", styles: [".slider,.slider *{box-sizing:border-box}.slider{display:block;width:100%;height:30px;padding:4px 10px;cursor:default;font-size:12px}.slider .bar{width:100%;background:#e8e8e8;height:10px;position:relative;border-radius:5px;box-shadow:inset 1px 1px 5px #bababa}.slider .bar>span.left-handle,.slider .bar>span.right-handle{display:inline-block;width:22px;height:22px;background:#bedcb2;border:7px solid #71b357;border-radius:50%;position:absolute;top:-7px;margin-left:-10px;z-index:1;cursor:pointer;transition:left .2s ease}.slider .bar>span.left-handle.last-active,.slider .bar>span.right-handle.last-active{z-index:2}.slider .bar>span.left-handle .handle-tooltip,.slider .bar>span.right-handle .handle-tooltip{display:block;position:absolute;top:-34px;left:-14px;border:1px solid #8fc37a;border-radius:4px;padding:1px 4px;min-width:20px;text-align:center;background:#d9ebd2;color:#71b357;font-weight:700;transition:opacity .2s ease;opacity:0}.slider .bar>span.left-handle .handle-tooltip:before,.slider .bar>span.right-handle .handle-tooltip:before{content:\"\";border:5px solid transparent;border-top-color:#8fc37a;position:absolute;top:104%;left:33%}.slider .bar>span.left-handle .handle-tooltip:after,.slider .bar>span.right-handle .handle-tooltip:after{content:\"\";border:5px solid transparent;border-top-color:#d9ebd2;position:absolute;top:100%;left:33%}.slider .bar>span.left-handle:hover>.handle-tooltip,.slider .bar>span.left-handle.active>.handle-tooltip,.slider .bar>span.right-handle:hover>.handle-tooltip,.slider .bar>span.right-handle.active>.handle-tooltip{opacity:1}.slider .bar div.filler{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px;border:1px solid #bedcb2}.slider .bar div.filler>span{display:inline-block;height:100%;position:absolute;top:0;background:#bedcb2;transition:all .2s ease}.slider .bar div.filler>div.step-indicators{width:100%;height:100%;position:relative}.slider .bar div.filler>div.step-indicators>span{width:1px;display:inline-block;height:10px;background:#71b357;position:absolute;left:0}.slider .values{display:block;font-weight:700;margin-top:4px;width:102%;margin-left:-1%;color:#908f90}.slider .values span:first-child{float:left}.slider .values span:last-child{float:right}.slider.disabled{opacity:.4}.slider.disabled .bar{box-shadow:none!important}.slider.disabled .bar>span.left-handle,.slider.disabled .bar>span.right-handle{cursor:not-allowed}.slider.disabled .bar>span.left-handle .handle-tooltip,.slider.disabled .bar>span.right-handle .handle-tooltip{display:none}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'npn-slider', template: "<!--npn-slider template-->\n<div class=\"slider\" [class.disabled]=\"isDisabled\">\n  <div class=\"bar\" (mousemove)=\"handlerSliding($event)\" (panmove)=\"handlerSliding($event)\">\n    <span class=\"left-handle\" [ngClass]=\"{'active': isHandlerActive && currentHandlerIndex === handlerIndex.left,\n                      'last-active': currentHandlerIndex === handlerIndex.left\n                    }\"\n      [style.left.%]=\"handlerX[handlerIndex.left]\" (mousedown)=\"setHandlerActive($event, handlerIndex.left)\" (panstart)=\"setHandlerActive($event, handlerIndex.left)\">\n      <span *ngIf=\"!hideTooltip\" class=\"handle-tooltip\">{{currentValues[handlerIndex.left]}}</span>\n    </span>\n    <div class=\"filler\">\n      <div class=\"step-indicators\">\n        <span *ngFor=\"let stepPos of stepIndicatorPositions\" [style.left.px]=\"stepPos\"></span>\n      </div>\n      <span *ngIf=\"multiRange\" [style.left.%]=\"handlerX[0]\" [style.width.%]=\"handlerX[handlerIndex.right] - handlerX[handlerIndex.left]\"></span>\n      <span *ngIf=\"!multiRange\" [style.left.%]=\"0\" [style.width.%]=\"handlerX[0]\"></span>\n    </div>\n    <span *ngIf=\"multiRange\" class=\"right-handle\" [ngClass]=\"{'active': isHandlerActive && currentHandlerIndex === handlerIndex.right,\n                      'last-active': currentHandlerIndex === handlerIndex.right\n                    }\"\n      [style.left.%]=\"handlerX[handlerIndex.right]\" (mousedown)=\"setHandlerActive($event, handlerIndex.right)\"\n      (panstart)=\"setHandlerActive($event, handlerIndex.right)\">\n      <span *ngIf=\"!hideTooltip\" class=\"handle-tooltip\">{{currentValues[handlerIndex.right]}}</span>\n    </span>\n  </div>\n  <div class=\"values\" *ngIf=\"!hideValues\">\n    <span>{{initValues[handlerIndex.left]}}</span>\n    <span>{{initValues[handlerIndex.right]}}</span>\n  </div>\n</div>\n", styles: [".slider,.slider *{box-sizing:border-box}.slider{display:block;width:100%;height:30px;padding:4px 10px;cursor:default;font-size:12px}.slider .bar{width:100%;background:#e8e8e8;height:10px;position:relative;border-radius:5px;box-shadow:inset 1px 1px 5px #bababa}.slider .bar>span.left-handle,.slider .bar>span.right-handle{display:inline-block;width:22px;height:22px;background:#bedcb2;border:7px solid #71b357;border-radius:50%;position:absolute;top:-7px;margin-left:-10px;z-index:1;cursor:pointer;transition:left .2s ease}.slider .bar>span.left-handle.last-active,.slider .bar>span.right-handle.last-active{z-index:2}.slider .bar>span.left-handle .handle-tooltip,.slider .bar>span.right-handle .handle-tooltip{display:block;position:absolute;top:-34px;left:-14px;border:1px solid #8fc37a;border-radius:4px;padding:1px 4px;min-width:20px;text-align:center;background:#d9ebd2;color:#71b357;font-weight:700;transition:opacity .2s ease;opacity:0}.slider .bar>span.left-handle .handle-tooltip:before,.slider .bar>span.right-handle .handle-tooltip:before{content:\"\";border:5px solid transparent;border-top-color:#8fc37a;position:absolute;top:104%;left:33%}.slider .bar>span.left-handle .handle-tooltip:after,.slider .bar>span.right-handle .handle-tooltip:after{content:\"\";border:5px solid transparent;border-top-color:#d9ebd2;position:absolute;top:100%;left:33%}.slider .bar>span.left-handle:hover>.handle-tooltip,.slider .bar>span.left-handle.active>.handle-tooltip,.slider .bar>span.right-handle:hover>.handle-tooltip,.slider .bar>span.right-handle.active>.handle-tooltip{opacity:1}.slider .bar div.filler{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px;border:1px solid #bedcb2}.slider .bar div.filler>span{display:inline-block;height:100%;position:absolute;top:0;background:#bedcb2;transition:all .2s ease}.slider .bar div.filler>div.step-indicators{width:100%;height:100%;position:relative}.slider .bar div.filler>div.step-indicators>span{width:1px;display:inline-block;height:10px;background:#71b357;position:absolute;left:0}.slider .values{display:block;font-weight:700;margin-top:4px;width:102%;margin-left:-1%;color:#908f90}.slider .values span:first-child{float:left}.slider .values span:last-child{float:right}.slider.disabled{opacity:.4}.slider.disabled .bar{box-shadow:none!important}.slider.disabled .bar>span.left-handle,.slider.disabled .bar>span.right-handle{cursor:not-allowed}.slider.disabled .bar>span.left-handle .handle-tooltip,.slider.disabled .bar>span.right-handle .handle-tooltip{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { setMinValues: [{
                type: Input,
                args: ['min']
            }], setMaxValues: [{
                type: Input,
                args: ['max']
            }], setMinSelectedValues: [{
                type: Input,
                args: ['minSelected']
            }], setMaxSelectedValues: [{
                type: Input,
                args: ['maxSelected']
            }], stepValue: [{
                type: Input,
                args: ['step']
            }], showStepIndicator: [{
                type: Input
            }], multiRange: [{
                type: Input
            }], setHideTooltip: [{
                type: Input,
                args: ['hide-tooltip']
            }], setHideValues: [{
                type: Input,
                args: ['hide-values']
            }], setDisabled: [{
                type: Input,
                args: ['disabled']
            }], onChange: [{
                type: Output
            }], setHandlerActiveOff: [{
                type: HostListener,
                args: ['document:mouseup']
            }, {
                type: HostListener,
                args: ['document:panend']
            }] } });

class NpnSliderModule {
}
NpnSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NpnSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderModule, declarations: [NpnSliderComponent], imports: [CommonModule], exports: [NpnSliderComponent] });
NpnSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NpnSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [NpnSliderComponent],
                    exports: [NpnSliderComponent]
                }]
        }] });

/*
 * Public API Surface of npn-slider
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NpnSliderComponent, NpnSliderModule };
